import React from 'react'
import classnames from 'classnames/bind'
import { Badge } from '@caudena/core/ui-kit'
import useHttp from '../../useHttp'

import styles from './index.scss'

const cx = classnames.bind(styles)

interface NavItemCounterProps {
  url?: string
  className?: string
}

interface CounterData {
  new?: number
  my?: number
  [key: string]: number | undefined
}

const NavItemCounter: React.FC<NavItemCounterProps> = ({
  url = null,
  className,
}) => {
  const { data = null } = useHttp(url, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    refreshInterval: 5000 * 60, // 5min in ms
  })

  if (!data || !url || (typeof data !== 'number' && typeof data !== 'object'))
    return null

  let total: number | CounterData = data as number | CounterData

  if (typeof total === 'object') {
    if (total.new !== undefined) {
      total = total.new
    } else {
      total = Object.keys(total).reduce((a: number, key: string) => {
        if (key === 'my') return a
        return a + (total as CounterData)[key]!
      }, 0)
    }
  }

  let label = String(total)

  if ((total as number) > 99) {
    label = '99+'
  }

  if (total === 0) {
    return null
  }

  return (
    <React.Fragment>
      <Badge className={cx('CounterBadge', className)} variant="error" rounded>
        {label}
      </Badge>
      <span className={cx('NavItemCounterIndicator')} />
    </React.Fragment>
  )
}

export default NavItemCounter
